import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import { Box } from '@mui/material';

import { RadioControlled } from 'components/_basic/Form/Radio';
import { CurrencyUnitSelector } from 'components/BusinessToolForm/components/CurrencyUnitSelector/CurrencyUnitSelector';
import { useGetPeriodOptions } from 'components/BusinessToolForm/constants/periods';
import { GLOBAL_PERIOD_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

import { IProjectedBalanceFormHeaderProps } from './types';
import { prefix, PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES } from '../../utils/form';

import styles from './ProjectedBalanceFormHeader.module.scss';

export const ProjectedBalanceFormHeader: FC<IProjectedBalanceFormHeaderProps> = ({ disabled = false }) => {
  const { control } = useFormContext();
  const periodOptions = useGetPeriodOptions();

  return (
    <Box className={styles.header}>
      <RadioControlled
        id={'projectedBalanceSheets.period'}
        name={GLOBAL_PERIOD_NAME}
        control={control}
        options={periodOptions}
        disabled={disabled}
      />

      <CurrencyUnitSelector
        name={concatWithDot(prefix, PROJECTED_BALANCE_SHEETS_FORM_SECTION_NAMES.CURRENCY)}
        disabled={disabled}
      />
    </Box>
  );
};
